import Icon from 'veui/components/Icon'

Icon.register({
  'file-key': {
    paths: [
      {
        d: 'M448 704a32 32 0 01-32 32H128a32 32 0 01-32-32V64a32 32 0 0132-32h512a32 32 0 0132 32v289a32 32 0 01-64 0V96H160v576h256a32 32 0 0132 32zm96-480a32 32 0 00-32-32H256a32 32 0 000 64h256a32 32 0 0032-32zM256 352a32 32 0 000 64h96a32 32 0 000-64zm449.93 353.65A101 101 0 01544.1 589.07L441 486a32 32 0 0145.25-45.26l11.7 11.7 26.18-26.19a32 32 0 0145.26 45.25l-26.19 26.19 46.13 46.13a101.22 101.22 0 01116.58 19 101.14 101.14 0 01.02 142.83zM660.68 608a37 37 0 100 52.37 36.79 36.79 0 000-52.37z'
      }
    ],
    width: '768',
    height: '768'
  }
})
